<template>
  <div>
    <div class="page-header">
      <div class="container-fluid d-flex align-items-center justify-content-between">
       <h2 class="h4 no-margin-bottom">Entegre Cariler</h2>
       <div class="right-menu list-inline no-margin-bottom">
        <!-- <router-link to="/create/cari"><button class="btn submit bg-dark text-light">
          Yeni Cari</button> </router-link>-->
          <button @click="cariKontrol" class="btn submit bg-dark text-light">Kontrol ({{yok}})</button> 
       </div>
      </div>
    </div>

        <section class="no-padding-top no-padding-bottom">
          <div class="block" >
            <div class="block-body">
              <div class="form-group">
                <div class="row">
                  <div class="col-lg-2 col-12">
                    <label class="form-control-label dashtext-3">Kodu ( * )</label>
                    <input type="text" class="form-control" v-model="newPost.kodu">
                  </div>
                  <div class="col-lg-4 col-12">
                    <label class="form-control-label dashtext-3">Takma isim ( * )</label>
                    <input type="text" class="form-control" v-model="newPost.alias">
                  </div>
                      <div class="col-lg-2 col-12">
                        <label class="form-control-label">Sağlayıcı</label>
                        <select v-model="newPost.said" class="form-control">
                          <option value="0">Sağlayıcı Yok</option>
                          <option v-for="(option,index) in sa" :value="option.id" :key="index">{{ option.alias }}</option>
                        </select>
                      </div>
                  <div class="col-lg-2 col-12">
                    <label class="form-control-label">Enlem</label>
                    <input type="text" class="form-control" v-model="newPost.enlem">
                  </div>
                  <div class="col-lg-2 col-12">
                    <label class="form-control-label">Boylam</label>
                    <input type="text" class="form-control" v-model="newPost.boylam">
                  </div>                        
                </div>
                <div class="row mt-3">
                  <div class="col-lg-2 col-12">
                    <label class="form-control-label">Telefon</label>
                    <input type="text" class="form-control" v-model="newPost.telefon">
                  </div>
                  <div class="col-lg-2 col-12">
                    <label class="form-control-label">Cep Telefonu</label>
                    <input type="text" class="form-control" v-model="newPost.cep">
                  </div>            
                  <div class="col-lg-3 col-12">
                    <label class="form-control-label">E-Posta</label>
                    <input type="text" class="form-control" v-model="newPost.posta">
                  </div>
                  <div class="col-lg-2 col-12">
                    <label class="form-control-label">ili</label>
                    <input type="text" class="form-control" v-model="newPost.il">
                  </div>
                  <div class="col-lg-2 col-12">
                    <label class="form-control-label">İlçe</label>
                    <input type="text" class="form-control" v-model="newPost.ilce">
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-lg-10 col-12">
                    <label class="form-control-label">Adres</label>
                    <input type="text" class="form-control" v-model="newPost.adres">
                    <span class="mt-3 dashtext-3" v-if="mode === 'Düzenle'">Yeni kayıt için sayfayı yenilemeyi unutmayınız</span>
                  </div>
                  <div class="col-lg-2 mt-4">
                    <button @click="cariEkle()"  class="btn btn-danger d-block w-100">{{mode}}</button>
                  </div>
                </div>
              </div> 
              </div> 
            </div> 
          <div class="row mb-2 p-2">
            <div class="col-12">
                <input class="form-control" placeholder="Genel Arama" id="arama" type="text" @keyup="this.$helper.tabloarama"/>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="block margin-bottom-sm">
                  <div class="table-responsive"> 
                    <table id="tablo" class="table table-striped">
                        <thead>
                          <tr>
                            <th>Kodu</th>
                            <th>Alias</th>
                            <th>İl</th>
                            <th>İlçe</th>
                            <th>Telefon</th>
                            <th>Düzenle</th>
                            <th>Detay</th>
                          </tr>
                        </thead>
                        <tbody>
                        <tr v-for="post in posts" :key="post.id">
                          <td>{{post.kodu}}</td>
                          <td>{{post.alias}}</td>
                          <td>{{post.il}}</td>
                          <td>{{post.ilce}}</td>
                          <td>{{post.telefon}}</td>
                          <td class="dashtext-3">
                            
                            <a  @click="aktar(post.id,post.kodu,post.alias,post.said,post.enlem,post.boylam,post.telefon,post.cep,post.posta,post.il,post.ilce,post.adres)"   href="javascript:void(0)">Düzenle</a>

                          </td>
                          <td>
                            <router-link :to="`/detay/cari/${post.id * 8589}`">Detay</router-link>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
        </section>
      <div v-if="progres.inprogres" class="loading"><img src="/set/ajax-loader.gif"/></div>
    </div>
</template>
<script>
import { decode } from 'js-base64';

  export default {
    created() {
      this.progres.inprogres = true
      this.yetki();
      this.cariUpdate();
    },
    data() {
      return {
        newPost:{
          id:0,
          kodu:'',
          alias:'',
          fid:this.$request.ayar().firmaid,
          said:0,
          enlem:'',
          boylam:'',
          ilce:'',
          il:'',
          adres:'',
          adres2:'',
          telefon:'',
          posta:'',
          cep:''
        },
        mode : 'Ekle',
        sa:[],
        mikrokayit:[],
        inProgress: false,
        search: '',
        posts: [],
        errors: [],
        txt:'',
        ayar:this.$request.ayar(),
        ya:this.$request.ayar().ya,
        kid:this.$request.ayar().kid,
        progres : {
          mesaj:'Bekleyiniz',
          inprogres:false
        },
        kisa:decode(this.$request.ayar().genel.s),
        yok : 0
      };
    },
    computed : {

    },
    methods: {
      yetki: function(){ // buradaki yetkilendirme değişecek bid de gelebilir sid de gelebilir.
  //      standart view servis yetkilendirmesi
          if (this.$helper.sayfayetki(982595)){
            let islem =false;
            switch(this.ya) {
              case 'said':
                this.ya = 'said';
                this.txt="where k.kid_ ="+this.kid
                islem = true
                break;
              case 'carid':
                this.ya='carid';
                islem = true;
                break;
              default:
                islem = true;
                this.ya = 'fid';
                this.txt="where s.firma ="+this.newPost.fid
            }
                if(islem){this.getPostsAsync()}
          }
          else{
                alert('Bu alanı kullanım yetkiniz yok')
                this.$router.go(-1)
          }
        },
      getPostsAsync() { 
        this.$request.get("caris/"+this.ya+"/"+this.ayar.kid+"/"+this.ayar.firmaid)
       //alert("caris/"+this.ya+"/"+this.ayar.kid+"/"+this.ayar.firmaid)
        .then(res => {
          console.log(res)
          this.posts = res.results
          this.sagetir();
          this.progres.inprogres = false
        })
        .catch(err => {this.errors.push(err)})
      },

      cariUpdate(){
        let progress = 0
        this.progres.inprogres = true
        this.$request.get("cariler/"+this.kisa)
        .then(res => {
          res.forEach(element => {
            //setTimeout(() => {
            let cari = {
              kodu:element.cari_kod,
              alias:element.cari_unvan1,
              fid:this.ayar.firmaid,
              said:0,
              enlem:0,
              boylam:0,
              il:element.adr_il,
              ilce:element.adr_ilce,
              adres:element.cadde_sokak,
              adres2:element.unvan2,
              telefon:element.adr_tel_no1
            }
            this.mikrokayit.push(cari)
            // this.cariKontrol(cari.kodu)
            // .then(res =>{
            //   if (res === true){ this.cariGuncelle(cari)}
            //   else{ this.cariEkle(cari)}
            // })
            // .catch(err => { alert("Cari Kontrol Hatası"+ err) })

            //},300);
            progress++
           
          });
           if (res.length === progress){this.progres.inprogres = false}
        })
      },
      cariKontrol(){
        this.progres.inprogres = true
        let cnt = 0
        let data = {}
        this.mikrokayit.forEach(element => {
          cnt++
          let varmi = this.posts.findIndex(obj => obj.kodu == element.kodu)
          if (varmi== -1) {
            this.yok = cnt
            data={
                  kodu:element.kodu,
                  alias:element.alias,
                  fid:this.$request.ayar().firmaid,
                  said:0,
                  enlem:'',
                  boylam:'',
                  ilce:element.ilce,
                  il:element.il,
                  adres:element.adres,
                  adres2:element.adres2,
                  telefon:element.telefon,
                  posta:'',
                  cep:element.telefon
            }
            this.$request.post('cari/',data).then(res => {
                this.cihazekle(res.id)
            })
            .catch(err=>{
              this.$swal(err.message)
            })
          }

        });
        if (this.mikrokayit.length == cnt) {
            this.progres.inprogres = false
          }
        //this.progres.inprogres = false

          //return new Promise ((resolve) => { 
            // this.$request.get("carikod/"+this.ayar.firmaid+"/"+kod)
            // .then(res => {
            //   if (res.results.length>0){ 
            //     resolve(true) 
            //     }
            //   else{ resolve(false)}
            // })
          //})
      },
      cihazekle(cid){
        let data = {
                firma : this.$request.ayar().firmaid,
                barkod :'000000',
                durum :4,
                cid:cid, // cari id 
                sa:0,  // sağlayıcı id
                kat:39,// kategori id
                tarih:0,
                lokasyon:''
             }
              this.$request.post('create/',data)

      },
      cariGuncelle(){
        this.$request.post('cariduzenle2/',this.newPost).then(res => {
          this.$swal("Düzenleme işlemi başarılı")
         this.getPostsAsync()
        })
        .catch(err=>{
          this.$swal(err.message)
        })

      },
      cariEkle(){
        if (this.mode === 'Ekle'){
          if (this.newPost.kodu && this.newPost.alias){
            this.$request.post('cari/',this.newPost).then(res => {
                this.$swal("Kayıt işlemi başarılı")
                this.getPostsAsync()
            })
            .catch(err=>{
              this.$swal(err.message)
            })
          }
          else{
            this.$swal("Girdileri Kontrol Et")
          }
        }
        else{
          this.cariGuncelle();
        }
      },
      aktar(id,kodu,alias,said,enlem,boylam,telefon,cep,posta,il,ilce,adres){
          this.mode = 'Düzenle'
          this.newPost.id=id
          this.newPost.kodu=kodu
          this.newPost.alias=alias
          this.newPost.said=said
          this.newPost.enlem=enlem
          this.newPost.boylam=boylam
          this.newPost.ilce=ilce
          this.newPost.il=il
          this.newPost.adres=adres
          this.newPost.telefon=telefon
          this.newPost.posta=posta
          this.newPost.cep=cep   

      },
        sagetir(){
          this.$request.get("sagetir/"+this.txt)
          .then(res => {
            if (res.status === 200){this.sa = res.results}
            else{
              this.sa.push({
                "id" : 0,
                "alias" : "Sağlayıcı yok"
              })
            }
          })
          .catch(err => this.error.push(err))
        },      
    }

  };
</script>
<style scoped>
@media
	  only screen 
    and (max-width: 760px), (min-device-width: 768px) 
    and (max-device-width: 1024px)  {
		table, thead, tbody, th, td, tr {
			display: block;
		}
		thead tr {
			position: absolute;
			top: -9999px;
			left: -9999px;
		}
    tr {
      margin: 0 0 1rem 0;
    }
    tr:nth-child(odd) {
      background: #ccc;
    }
		td {
			border: none;
			border-bottom: 1px solid #eee;padding-left: 50%;
			position: relative;
		}
		td:before {
			position: absolute;
			top: 0;
			left: 6px;
			width: 45%;
			padding-right: 10px;
			white-space: nowrap;
		}
		td:nth-of-type(1):before { content: "id"; }
		td:nth-of-type(2):before { content: "Alias"; }
		td:nth-of-type(3):before { content: "Model"; }
		td:nth-of-type(4):before { content: "Barkod"; }
		td:nth-of-type(5):before { content: "Cari"; }
		td:nth-of-type(6):before { content: "Durum"; }
		td:nth-of-type(7):before { content: "Detay"; }
	}
@media screen and (min-width: 992px) and (max-width: 2000px) {
table, td, th {  
  /*border: 1px solid #ddd;*/
  text-align: left;
}
table {
  border-collapse: collapse;
  width: 100%;
}
th, td {
  padding:15px;
}
}
</style>



// WEBPACK FOOTER //
// src/views/cari/cari.vue